import { render, staticRenderFns } from "./dataBoard.vue?vue&type=template&id=07dc552e&scoped=true"
import script from "./dataBoard.vue?vue&type=script&lang=js"
export * from "./dataBoard.vue?vue&type=script&lang=js"
import style0 from "./dataBoard.vue?vue&type=style&index=0&id=07dc552e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc552e",
  null
  
)

export default component.exports